import React, { useState, useRef, useEffect } from "react";
import "./orderinfo.css";
import firebase from "./../../config/fbConfig.js";
import restaurantList from "./../restaurants/restaurantsList";
import restaurantListHe from "./../restaurants/restaurantsListHe";
import { Helmet } from "react-helmet";

const LiveDB = firebase.database();
const auth = firebase.auth();

function SpecificOrderInfo(props) {
	const [order, setOrder] = useState({
		fullName: false,
		cart: { counter: 0, products: [{ name: null, options: [], extras: [], price: 0, totalPrice: 0, noDelivery: false }], totalPrice: 0 },
	});
	const [missing, setMissing] = useState(0); // 0 = loading, 1 = loaded and null, 2 = loaded and got all details from live doc
	// For security term, adding 3 numbers after the ID, then cutting them off in this component to get actual ID
	const id = useRef(props.match.params.id.substring(0, props.match.params.id.length - 3));
	const orderAuth = useRef(); // Used to store the auth.check if user logged/not, and remove it when unmounting

	let DeOptimizeCart = (arr) => {
		let DeOptimizeExtras = (extras) => {
			if (extras == null) return null;
			let newArr = [];
			let obj = {};
			for (let i = 0; i < extras.length; i++) {
				obj.name = extras[i].n;
				obj.price = extras[i].p;
				newArr.push(obj);
				obj = {};
			}
			return newArr;
		};

		let newArr = [];
		let obj = {};
		for (let i = 0; i < arr.length; i++) {
			obj.name = arr[i].n;
			obj.price = arr[i].p;
			obj.totalPrice = arr[i].t;
			obj.options = arr[i].o != null ? arr[i].o : null;
			obj.extras = DeOptimizeExtras(arr[i].e);
			newArr.push(obj);
			obj = {};
		}
		return newArr;
	};

	let DeOptimizeObject = (obj) => {
		let x = {
			service: obj.s,
			restaurant: obj.r,
			chosenTime: obj.x, // because this is the 1 before last letter and easy to remember
			state: obj.z, // because this is the last letter and most important to remember
			fullName: obj.n,
			phoneNum: obj.q,
			address: obj.a,
			timestamp: obj.t,
			cart: DeOptimizeCart(obj.c),
			totalPrice: obj.p,
			i: obj.i,
		};
		return x;
	};
	let getNameState = (state) => {
		if (window.location.href.includes("/en")) {
			if (state == 0) return "PENDING";
			if (state == 1) return "DENIED";
			if (state == 2) return "ACCEPTED";
			if (state == 3) return "ACCEPTED"; // with delay
		} else {
			if (state == 0) return "ממתין לאישור";
			if (state == 1) return "נדחה";
			if (state == 2) return "התקבלה בהצלחה";
			if (state == 3) return "התקבלה בהצלחה"; // with delay
		}
	};

	let getNameService = (service) => {
		if (window.location.href.includes("/en")) {
			if (service == 1) return "Takeaway";
			if (service == 2) return "Delivery";
			if (service == 3) return "Table Reserveation";
		} else {
			if (service == 1) return "טייק-אווי";
			if (service == 2) return "משלוח";
			if (service == 3) return "שולחן מוכן";
		}
	};

	let getStyleState = (state) => {
		if (state == 0) return { color: "rgb(170, 0, 0)" };
		if (state == 1) return { color: "red" };
		if (state == 2 || state == 3) return { color: "green" };
	};

	useEffect(() => {
		orderAuth.current = auth.onAuthStateChanged((user) => {
			if (user) {
				let id = user.uid;
				LiveDB.ref("8aEMdD9fd9A7")
					.update({
						[id]: true,
					})
					.then(() => {
						if (navigator.userAgent !== "ReactSnap") orderEffectFunc();
					});
			}
		});
		return () => {
			orderAuth.current();
		};
	}, [order.state]);

	// Used for first useEffect, moved into individual function for better looking code
	let orderEffectFunc = () => {
		let retrievedObject = localStorage.getItem("myOrder");
		let order = JSON.parse(retrievedObject);
		if (retrievedObject !== "" && retrievedObject !== null && order.id === id.current) {
			// Updating the state in case it was changed while the user wasnt watching and loaded from localStorage
			new Promise((resolve, reject) => {
				LiveDB.ref()
					.child("orders/" + id.current + "/z")
					.once("value")
					.then((snap) => {
						if (order.z != snap.val()) {
							order.z = snap.val();

							if (order.z != 3) {
								resolve(order);
							} else {
								// If it was changed to 3, so a new time was defined as well
								LiveDB.ref()
									.child("orders/" + id.current + "/x")
									.once("value")
									.then((snap) => {
										order.x = snap.val();
										resolve(order);
									});
							}
						} else {
							resolve(order);
						}
					});
			}).then((order) => {
				localStorage.setItem("myOrder", JSON.stringify(order));
				retrievedObject = DeOptimizeObject(order);
				setOrder(retrievedObject);
				setMissing(2);
			});
		} else {
			// Genereting info from database, because not in local storage
			const orderRef = LiveDB.ref().child("orders/" + id.current);
			orderRef.once("value").then(function (snapshot) {
				if (snapshot.val() == null) {
					setMissing(1);
				} else {
					// If there was found more than 1 result
					if (Object.keys(snapshot.val()).length > 1) {
						if (Object.keys(snapshot.val())[1].startsWith("-M")) {
							setMissing(1);
							return;
						}
					}
					let obj = { ...snapshot.val(), id: id.current };
					localStorage.setItem("myOrder", JSON.stringify(obj));
					window.location.reload();
				}
			});
		}
		// Check for changes only while it is on pending
		if (order != null) {
			if (order.z == 0) {
				const stateRef = LiveDB.ref().child("orders/" + id.current);
				stateRef.on("child_changed", function (snapshot) {
					order[snapshot.key] = snapshot.val();
					localStorage.setItem("myOrder", JSON.stringify(order));
					let retrievedObject = DeOptimizeObject(order);
					setOrder(retrievedObject);
					stateRef.off("child_changed");
				});
			}
		}
	};

	// Start listening to the database if it's on state Denied, then once it removed, let the user know and redirect him to the homepage
	useEffect(() => {
		const stateRef = LiveDB.ref().child("orders/" + id.current);
		if (order.state == 1) {
			stateRef.once("child_removed", () => {
				localStorage.removeItem("myOrder");
				if (window.location.href.includes("/en")) {
					alert("Your order was declined by the resturant, thus also removed our live tracking service.\nYou've received a full refund.");
				} else {
					alert("ההזמנה שלך נדחתה עקב החלטת המסעדה, לכן ההזמנה שלך נמחקה משירות מעקב ההזמנות שלנו\nנשלח לך החזר כספי מלא.");
				}
				props.history.push("/");
			});
		}
	}, [order.state]);

	let getDateFormat = (timestamp) => {
		let dateFormat = new Date(timestamp * 1000);
		let firstPart = dateFormat.toLocaleDateString("en-GB");
		let hours = "";
		let minutes = "";

		if (dateFormat.getHours() < 10) {
			hours = "0" + dateFormat.getHours();
		} else {
			hours = dateFormat.getHours();
		}

		if (dateFormat.getMinutes() < 10) {
			minutes = "0" + dateFormat.getMinutes();
		} else {
			minutes = dateFormat.getMinutes();
		}

		return `${firstPart} ${hours}:${minutes}`;
	};

	let cancelOrder = () => {
		if (window.location.href.includes("/en")) {
			if (!window.confirm("Are you sure you want to cancel your order and get a full refund?")) return;
		} else {
			if (!window.confirm("האם אתה בטוח שברצונך לבטל את ההזמנה ולקבל החזר כספי מלא?")) return;
		}

		let totalMoney = order.totalPrice.toFixed(2);

		const getRefund = firebase.functions().httpsCallable("getRefund");
		getRefund({ id: order.i, money: totalMoney })
			.then((res) => {
				// If the refund was completed, so move to homepage and remove it from the database
				if (res.data.status === "COMPLETED" || res.data.status === "CREATED") {
					LiveDB.ref()
						.child("orders/" + id.current)
						.set(null);
					localStorage.removeItem("myOrder");
					if (window.location.href.includes("/en")) {
						alert("Succesfully cancelled");
						props.history.push("/en");
					} else {
						alert("בוטל בהצלחה");
						props.history.push("/");
					}
				}
			})
			.catch((err) => {
				alert(`There was an error, ${err}`);
			});
	};

	// If it is a Hebrew page, so render it in english
	if (window.location.href.includes("/en")) {
		return (
			<div id="specificOrder">
				<Helmet>
					<html lang="en" />
					<title>Order Tracking | Itay's Restaurant</title>
					<meta name="description" content="Get live updates about the current state of your order ! Itay's Restaurant (© Itay Shiff)" />
					<meta name="robots" content="unindex, unfollow" />
				</Helmet>

				{missing == 0 && <img id="loadingGif" src="/assets/loadingGif.gif" />}

				{missing == 1 && (
					<div id="wrongInformation">
						<div>No order found 😔</div>
						<div>This could happen for the following reasons:</div>
						<ol>
							<li>You tried accessing an incorrect Tracking ID. Make sure you have the right link provided to you when you made the purchase.</li>
							<li>You order was denied due to the restaurants decision, thus your order was removed from our live tracking service.</li>
							<li>Your order isn't available anymore because you've been refunded.</li>
						</ol>
						<div>Thank you for your patience</div>
					</div>
				)}

				{missing == 2 && (
					<React.Fragment>
						<div id="dateFormat">{getDateFormat(order.timestamp)}</div>

						<div id="fullNameOrder">Hello {order.fullName}!</div>

						<div id="infoAboutOrder">Information about your order:</div>

						<div className="titlesOrder">
							Full Name:<span> {order.fullName}</span>{" "}
						</div>
						<div className="titlesOrder">
							Phone Number:<span> {order.phoneNum}</span>
						</div>
						<div className="titlesOrder">
							Requested Service:
							<span>
								{" "}
								{getNameService(order.service)} from {restaurantList[order.restaurant].title}'s restaurant
							</span>{" "}
						</div>
						<div className="titlesOrder">
							{getNameService(order.service)} requested time:
							{order.state == 3 ? (
								<span>
									The restaurant changed your hour to <b>{order.chosenTime}</b>.
								</span>
							) : (
								<span>{order.chosenTime}</span>
							)}
						</div>

						<div className="titlesOrder">
							Current state of your order:
							{order.state == 1 ? (
								<React.Fragment>
									<span id="changingState" style={getStyleState(order.state)}>
										{" "}
										{getNameState(order.state)}{" "}
									</span>
									<div style={{ color: "black", border: "3px solid black", padding: "15px", marginTop: "15px" }}>
										You will get a refund in less than 10 minutes. Try again later please.
									</div>
								</React.Fragment>
							) : (
								<span id="changingState" style={getStyleState(order.state)}>
									{" "}
									{getNameState(order.state)}
								</span>
							)}
						</div>

						<div style={{ paddingBottom: "15px", paddingTop: "20px", textAlign: "center", marginRight: "40px", fontWeight: "bold" }}>Your Order</div>

						<ul id="cartSpecific">
							<li style={{ fontWeight: "900" }}>
								PRODUCT
								<span>PRICE</span>
							</li>
							{order.cart.map((product, index) => (
								<li key={product.name + index}>
									<div className="CartNameProduct">
										<div className="cartNameWrapper">
											{product.name}
											{product.options != null && <div> ({product.options.join(", ")}) </div>}
										</div>
										<div className="specificPriceCart">{product.price}</div>
									</div>

									{product.extras != null && (
										<ul className="extrasAdded">
											<div>Extras added:</div>
											{product.extras.map((extraName, index) => (
												<li key={extraName + index}>
													<div className="extraName">{extraName.name}</div>
													<span className="priceExtra">{extraName.price}</span>
												</li>
											))}
											<div className="TotalPrice">
												Total Price For This Item: <span>{product.totalPrice}</span>
											</div>
										</ul>
									)}
								</li>
							))}
						</ul>
						<div className="totalPriceCart">
							Total Price For Whole Items: <span>{order.totalPrice}</span>
						</div>

						{order.state == 0 && <button onClick={cancelOrder}>Cancel My Order</button>}
					</React.Fragment>
				)}
			</div>
		);
	}

	// Else render it in Hebrew
	return (
		<div id="specificOrder" className="hebrew">
			<Helmet>
				<title>מעקב הזמנה | המסעדה של איתי</title>
				<meta name="description" content="Get live updates about the current state of your order ! Itay's Restaurant (© Itay Shiff)" />
				content="מעקב בלייב אחרי מצב ההזמנה שלכם ! המסעדה של איתי (איתי שיף ©)"
				<meta name="robots" content="unindex, unfollow" />
			</Helmet>

			{missing == 0 && <img id="loadingGif" src="/assets/loadingGif.gif" />}

			{missing == 1 && (
				<div id="wrongInformation">
					<div>לא נמצאו פרטים על ההזמנה שלך 😔</div>
					<div>ייתכן שמצב זה נובע ממספר סיבות:</div>
					<ol>
						<li>מספר המזהה של המעקב האישי שיש ברשותך שגוי. נא לוודא שיש ברשותך את הלינק הנכון שסיפקנו לך ברגע שביצעת את הרכישה.</li>
						<li>ההזמנה שלך נדחתה עקב החלטת המסעדה, לכן ההזמנה שלך נמחקה משירות מעקב ההזמנות שלנו.</li>
						<li>ההזמנה שלך לא זמינה יותר משום שקיבלת החזר כספי (אם כי ביקשת אותו או כי המסעדה ביצעה זאת).</li>
					</ol>
					<div>תודה לך על הסבלנות</div>
				</div>
			)}

			{missing == 2 && (
				<React.Fragment>
					<div id="dateFormat">{getDateFormat(order.timestamp)}</div>

					<div id="fullNameOrder">שלום {order.fullName}!</div>

					<div id="infoAboutOrder">פרטים על ההזמנה שלך:</div>

					<div className="titlesOrder">
						שם מלא:<span> {order.fullName}</span>{" "}
					</div>
					<div className="titlesOrder">
						מספר פלאפון:<span> {order.phoneNum}</span>
					</div>
					<div className="titlesOrder">
						שירות מבוקש:
						<span>
							{" "}
							{getNameService(order.service)} ממסעדת {restaurantListHe[order.restaurant].title}
						</span>{" "}
					</div>
					<div className="titlesOrder">
						זמן מבוקש ל{getNameService(order.service)}:
						{order.state == 3 ? (
							<span>
								המסעדה שינתה את שעת הקבלה שלך לשעה <b>{order.chosenTime}</b>.
							</span>
						) : (
							<span>{order.chosenTime}</span>
						)}
					</div>

					<div className="titlesOrder">
						מצב נוכחי של ההזמנה שלך:
						{order.state == 1 ? (
							<React.Fragment>
								<span id="changingState" style={getStyleState(order.state)}>
									{" "}
									{getNameState(order.state)}{" "}
								</span>
								<div style={{ color: "black", border: "3px solid black", padding: "15px", marginTop: "15px" }}>
									המסעדה החליטה לבטל את ההזמנה שלך. את/ה תקבל/י החזר כספי מלא ב10 דקות הקרובות.
								</div>
							</React.Fragment>
						) : (
							<span id="changingState" style={getStyleState(order.state)}>
								{" "}
								{getNameState(order.state)}
							</span>
						)}
					</div>

					<div style={{ paddingBottom: "15px", paddingTop: "20px", textAlign: "center", marginRight: "40px", fontWeight: "bold" }}>ההזמנה שלך</div>

					<ul id="cartSpecific">
						<li style={{ fontWeight: "900" }}>
							שם המנה
							<span>מחיר</span>
						</li>
						{order.cart.map((product, index) => (
							<li key={product.name + index}>
								<div className="CartNameProduct">
									<div className="cartNameWrapper">
										{product.name}
										{product.options != null && <div> ({product.options.join(", ")}) </div>}
									</div>
									<div className="specificPriceCart">{product.price}</div>
								</div>

								{product.extras != null && (
									<ul className="extrasAdded">
										<div>תוספות שבחרת להוסיף:</div>
										{product.extras.map((extraName, index) => (
											<li key={extraName + index}>
												<div className="extraName">{extraName.name}</div>
												<span className="priceExtra">{extraName.price}</span>
											</li>
										))}
										<div className="TotalPrice">
											מחיר כולל של מנה זו: <span>{product.totalPrice}</span>
										</div>
									</ul>
								)}
							</li>
						))}
					</ul>
					<div className="totalPriceCart">
						מחיר סופי עבור כל הפריטים: <span>{order.totalPrice}</span>
					</div>

					{order.state == 0 && <button onClick={cancelOrder}>ביטול ההזמנה שלי</button>}
				</React.Fragment>
			)}
		</div>
	);
}

export default SpecificOrderInfo;
